import React from 'react';
import './BankManagement.scss'; // Import the stylesheet
import {
  useGetAccountBanksQuery,
  useDeleteAccountBankMutation,
} from 'services';
import { Loading } from 'components';
import { Icon } from 'modules';
import toast from 'react-hot-toast';
import { useState } from 'react';
import { BankAccountEntity } from 'services/openapi';
import { PopupWraper } from 'components';
import { Button } from 'modules';
import CreateAccountBank from './create';
const BankManagementFeature = () => {
  const { data, isLoading, refetch } = useGetAccountBanksQuery();
  const {
    mutateAsync: deleteAccountBank,
    isLoading: isLoadingDeleteAccountBank,
    isError,
  } = useDeleteAccountBankMutation();
  const [openPopUpRemoveUser, setOpenPopUpRemoveUser] =
    useState<BankAccountEntity | null>(null);
  const [openPopUpCreateAccountBank, setOpenPopUpCreateAccountBank] =
    useState<boolean>(false);

  const getTextSecret = (text: string) => {
    if (text.length < 10) {
      return text.slice(0, 2) + '****' + text.slice(-2);
    } else {
      return text.slice(0, 4) + '****' + text.slice(-4);
    }
  };

  const handleRemoveAccountBank = async (values: any) => {
    try {
      await deleteAccountBank(values.id);
      toast.success('Xóa tài khoản ngân hàng thành công');
      setOpenPopUpRemoveUser(null);
      refetch();
    } catch (error) {}
  };

  return (
    <div className='bank-management'>
      <h1>Quản lý tài khoản ngân hàng</h1>
      <Button
        style={{ marginBottom: 10, marginTop: 10 }}
        label='Thêm tài khoản ngân hàng'
        buttonType='success'
        onClick={() => setOpenPopUpCreateAccountBank(true)}
      />
      <Loading isLoading={isLoading}>
        <div className='bank-management-content'>
          {/* {[...data?.data ?? [], ...data?.data ?? [], ...data?.data ?? []]?.map((e, index) => { */}
          {data?.data?.map((e, index) => {
            return (
              <div key={index} className='bank-account-container'>
                <div className='bank-account'>
                  <img className='image-bank' src={e.bank.logo} alt='Bank' />
                  <div className='account-details'>
                    <p
                      style={{
                        fontSize: 18,
                        fontWeight: 'bold',
                        color: '#04cdf9',
                      }}
                    >
                      {e.bank.shortName}- {e.bank.name}
                    </p>
                    <p style={{ fontSize: 18, fontWeight: 'bold' }}>
                      {e.accountName}
                    </p>
                    <p style={{ fontSize: 18, fontWeight: 'bold' }}>
                      {getTextSecret(e.accountNumber)}
                    </p>
                  </div>
                </div>
                <div
                  className='btnClose'
                  onClick={() => {
                    setOpenPopUpRemoveUser(e);
                  }}
                >
                  <Icon.Trash />
                </div>
              </div>
            );
          })}
        </div>
      </Loading>
      {openPopUpRemoveUser && (
        <PopupWraper
          center
          title='Xóa tài khoản'
          onClose={() => setOpenPopUpRemoveUser(null)}
        >
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className='label'>
                  Bạn có chắc chắn muốn xóa Tài khoản ngân hàng này không?
                </div>
              </div>
            </div>
          </div>

          <div className='wrap-button-remove-user'>
            <Button
              label='Xóa'
              buttonType='success'
              onClick={() => handleRemoveAccountBank(openPopUpRemoveUser)}
            />
            <Button
              label='Hủy'
              buttonType='grey'
              onClick={() => setOpenPopUpRemoveUser(null)}
            />
          </div>
        </PopupWraper>
      )}
      {openPopUpCreateAccountBank && (
        <CreateAccountBank
          onClose={() => setOpenPopUpCreateAccountBank(false)}
          forceUpdateTable={() => refetch()}
        ></CreateAccountBank>
      )}
    </div>
  );
};

export default BankManagementFeature;
